require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /Users/yuki/Dropbox/Mac/Desktop/web design/dog-ema-wp/wp-content/themes/ema/node_modules/core-js/modules/es6.array.species.js
// module id = 257
// module chunks = 0